import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { StudentCabinetNavigationService } from '../../../../shared/routing/service/student-cabinet-navigation';

@Component({
  selector: 'app-referral-redirect',
  template: '',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralRedirectComponent implements OnInit {
  private studentCabinetNavigationService = inject(StudentCabinetNavigationService);

  ngOnInit(): void {
    const params = new URLSearchParams(window.location.search);
    const url = this.studentCabinetNavigationService.getReferralLink();
    window.location.replace(`${url}?${params.toString()}`);
  }
}
